import React__default from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { Spinner } from '../Spinner/Spinner.js';

var getBadgeIcon = function getBadgeIcon(type) {
  var css = 'rounded-full flex-shrink-0 mr-2';

  switch (type) {
    case 'success':
      return React__default.createElement(Icon, {
        name: "tick",
        className: cn(css, 'yt-green-solid')
      });

    case 'warning':
      return React__default.createElement(Icon, {
        name: "warning",
        className: cn(css, 'yt-yellow-solid')
      });

    case 'error':
      return React__default.createElement(Icon, {
        name: "warning",
        className: cn(css, 'yt-red-solid')
      });

    case 'information':
      return React__default.createElement(Icon, {
        name: "info",
        className: cn(css, 'yt-blue-solid')
      });

    case 'loading':
      return React__default.createElement(Spinner, {
        delay: 0,
        className: cn(css, 'h-6 w-6')
      });

    default:
      return null;
  }
};

export { getBadgeIcon };
//# sourceMappingURL=util.js.map
